import { getSettingSelfServeRetailerTaxonomy } from "@faire/help-center-utils/settings/getSettingSelfServeRetailerTaxonomy";
export var HowToFindBrandsThatHaveInsiderFreeShippingIA = function HowToFindBrandsThatHaveInsiderFreeShippingIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return HOW_TO_FIND_BRANDS_WITH_INSIDER_FREE_SHIPPING(strictLocalize);
    },
    getDescription: function getDescription() {
      return [TO_FIND_BRANDS_AND_PRODUCTS_OFFERING_INSIDER_FREE_SHIPPING(strictLocalize)];
    }
  };
};
var HOW_TO_FIND_BRANDS_WITH_INSIDER_FREE_SHIPPING = function HOW_TO_FIND_BRANDS_WITH_INSIDER_FREE_SHIPPING(strictLocalize) {
  return getSettingSelfServeRetailerTaxonomy() ? strictLocalize({
    id: "PYlSze",
    defaultMessage: [{
      "type": 0,
      "value": "Trouvez les marques proposant la livraison gratuite avec Insider"
    }]
  }) : strictLocalize({
    id: "B8cwFF",
    defaultMessage: [{
      "type": 0,
      "value": "Comment trouver des marques proposant la livraison gratuite avec Insider ?"
    }]
  });
};
var TO_FIND_BRANDS_AND_PRODUCTS_OFFERING_INSIDER_FREE_SHIPPING = function TO_FIND_BRANDS_AND_PRODUCTS_OFFERING_INSIDER_FREE_SHIPPING(strictLocalize) {
  return strictLocalize({
    id: "HHlKBq",
    defaultMessage: [{
      "type": 0,
      "value": "Pour trouver des marques et des produits offrant la livraison gratuite avec Insider, il vous suffit de chercher le symbole de la clé bleue « Livraison gratuite avec Insider » lorsque vous parcourez notre plateforme. Lorsque vous voyez un produit ou une marque avec ce symbole, vous bénéficiez automatiquement de la livraison gratuite avec Insider lors du paiement de votre commande auprès de cette marque. De plus, vous pouvez personnaliser votre expérience d'achat pour afficher uniquement les produits bénéficiant de la livraison gratuite avec Insider. Pour ce faire, localisez le filtre Insider situé en haut de la catégorie que vous parcourez et cliquez dessus."
    }]
  });
};